import React from "react";

class LiquidateCTV extends React.Component {
  state = { stackId: null };

  handleClick = e => {

	  var inputInt = document.getElementById("inputInt");    
	  var inputAddress = document.getElementById("inputAddress");    

	  
	  this.setValue(inputInt.value, inputAddress.value);
	  
	  
  };

  setValue = (spxToLiquidate, addressToLiquidate) => {
	console.log("in onclick " +  spxToLiquidate + ", " + addressToLiquidate);
    const { drizzle, drizzleState } = this.props;
    const contract = drizzle.contracts.VaultSystem;

    // let drizzle know we want to call the `set` method with `value`
    const stackId = contract.methods["liquidateNonCompliant"].cacheSend(spxToLiquidate, addressToLiquidate, {
      from: drizzleState.accounts[0]
    });

    // save the `stackId` for later reference
    this.setState({ stackId });
  };

  getTxStatus = () => {
    // get the transaction states from the drizzle state
    const { transactions, transactionStack } = this.props.drizzleState;

    // get the transaction hash using our saved `stackId`
    const txHash = transactionStack[this.state.stackId];

    // if transaction hash does not exist, don't display anything
    if (!txHash) return null;

    // otherwise, return the transaction status
    return `Transaction status: ${transactions[txHash] && transactions[txHash].status}`;
  };

  render() {
    return (
       <div>
		<div>
			<p>Address of non-compliant CTV owner (EOA)</p><input type="text" name="inputAddress" id="inputAddress"/>
			<p>Number of vSPY you want to return to the CTV to help liquidate it, multiplied by 10^18 and expressed as an integer:</p> <input type="text" name="inputInt" id="inputInt"/>
			<input type="submit" value="Submit" onClick={this.handleClick}/>
		</div> 
        <div>{this.getTxStatus()}</div>
      </div>
    );
  }
}

export default LiquidateCTV;